"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxLabelSizes = exports.CheckboxSizes = exports.CheckboxVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const FieldBox_1 = require("../FieldBox");
const checkMark_svg_1 = __importDefault(require("../../icons/checkMark.svg"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var CheckboxVariants;
(function (CheckboxVariants) {
    CheckboxVariants["Default"] = "default";
    CheckboxVariants["Primary"] = "primary";
})(CheckboxVariants || (exports.CheckboxVariants = CheckboxVariants = {}));
var CheckboxSizes;
(function (CheckboxSizes) {
    CheckboxSizes["Large"] = "large";
    CheckboxSizes["Medium"] = "medium";
    CheckboxSizes["Small"] = "small";
})(CheckboxSizes || (exports.CheckboxSizes = CheckboxSizes = {}));
var CheckboxLabelSizes;
(function (CheckboxLabelSizes) {
    CheckboxLabelSizes["MediumBold"] = "mediumBold";
    CheckboxLabelSizes["MediumNormal"] = "mediumNormal";
    CheckboxLabelSizes["SmallBold"] = "smallBold";
})(CheckboxLabelSizes || (exports.CheckboxLabelSizes = CheckboxLabelSizes = {}));
const CheckboxIcon = ({ size }) => ((0, jsx_runtime_1.jsx)(checkMark_svg_1.default, { size: size === CheckboxSizes.Small ? 8 : 12 }));
const Checkbox = react_1.default.forwardRef(({ checked = false, disabled = false, size = CheckboxSizes.Medium, label, labelSize = CheckboxLabelSizes.MediumNormal, onChange, name, onFocus, onBlur, value, rtl = false, variant = CheckboxVariants.Default, palette = FieldBox_1.FieldBoxPalette.Light, }, ref) => {
    const handleChange = (0, react_1.useCallback)((event) => {
        if (onChange) {
            onChange(event.target.checked, event);
        }
    }, [onChange]);
    return ((0, jsx_runtime_1.jsxs)("label", { className: (0, classnames_1.default)(styles_module_css_1.default.root, rtl && styles_module_css_1.default.rtl), children: [(0, jsx_runtime_1.jsx)("input", { ref: ref, name: name, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, value: value, checked: Boolean(checked), disabled: disabled, type: "checkbox", className: styles_module_css_1.default.field }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.checkbox, styles_module_css_1.default[size], styles_module_css_1.default[variant], {
                    [styles_module_css_1.default.indeterminate]: checked === null,
                    [styles_module_css_1.default[palette]]: palette,
                }), children: checked && (0, jsx_runtime_1.jsx)(CheckboxIcon, { size: size }) }), label && ((0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(styles_module_css_1.default.label, styles_module_css_1.default[`label_${labelSize}`]), children: label }))] }));
});
exports.default = Checkbox;
